import {DecimalPipe} from '@angular/common'
import {Component, computed, inject} from '@angular/core'
import {HemnetService} from '../../services/hemnet.service'
import {ItemComponent} from './item/item.component'

@Component({
  selector: 'spb-calculation',
  templateUrl: './calculation.component.html',
  styleUrls: ['./calculation.component.scss'],
  imports: [DecimalPipe, ItemComponent]
})
export class CalculationComponent {

  public readonly hemnetService = inject(HemnetService)
  public loanAmount = computed(() => {
    return this.hemnetService.askingPrice() - this.hemnetService.downPayment()
  })
  public yearlyInterest = computed(() => {
    return this.loanAmount() * this.hemnetService.interestRate() / 100
  })
  public monthlyInterest = computed(() => {
    return Math.ceil(this.yearlyInterest() / 12)
  })
  public monthlyTaxReduction = computed(() => {
    const month30 = Math.min(this.yearlyInterest(), 100_000)
    const month21 = Math.max(this.yearlyInterest() - 100_000, 0)
    return Math.ceil((month30 * 0.3 + month21 * 0.21) / 12)
  })

  public runCost = computed(() => {
    return this.hemnetService.runCost() / 12
  })
  public fee = computed(() => {
    return this.hemnetService.fee() ?? 0
  })
  public amortizationPercent = computed(() => {
    const degree = this.loanAmount() / this.hemnetService.askingPrice()
    return this.rates.reduce(
      (current, rate) => degree > rate.rate ? rate.value : current, 0)
  })
  public amortization = computed(() =>
    Math.ceil(this.loanAmount() * this.amortizationPercent() / 12))
  public monthlyCost = computed(() =>
    this.fee() + this.amortization() + this.runCost() + this.monthlyInterest() - this.monthlyTaxReduction())

  private readonly rates = [
    {rate: 0.5, value: 0.01},
    {rate: 0.7, value: 0.02}
  ]
}
